import type { PublicTelemetry } from './events';

export function observeRuntimePerformance(
  telemetry: PublicTelemetry,
  pageId: string,
  startedAt: number,
): void {
  telemetry.emit({
    name: 'public_runtime_boot',
    pageId,
    ok: true,
    durationMs: Math.round(performance.now() - startedAt),
  });
}

export function observeWebVital(
  telemetry: PublicTelemetry,
  pageId: string,
  name: 'CLS' | 'FID' | 'INP' | 'LCP' | 'FCP' | 'TTFB',
  value: number,
): void {
  telemetry.emit({
    name: 'public_web_vital_reported',
    pageId,
    ok: true,
    durationMs: Math.round(value),
    context: { webVital: name },
  });
}
